<template>
  <section class="section section--flush" id="products">
    <div class="wrap">
      <div class="sec-head reveal" v-reveal>
        <p class="sec-eyebrow">02 / PRODUCTS / 产品</p>
        <h2>我们自己的产品</h2>
        <p>服务按你的业务定制, 产品供更多客户直接使用。目前三个已上线, 一个开发中。</p>
      </div>
      <div class="cards">
        <div class="card product-card reveal" v-reveal>
          <span class="product-badge">已上线</span>
          <p class="card-idx">product / 01</p>
          <h3>微米知行</h3>
          <p>将你的课程、讲义与资料, 转化为可持续演进的知识资产; AI 问答、智能体工作流与会员支付打通, 完成变现闭环。主要服务知识 IP、培训机构、一人公司、MCN 与中小企业。</p>
          <div class="tags">
            <span class="tag">知识 IP</span>
            <span class="tag">培训机构</span>
            <span class="tag">一人公司</span>
            <span class="tag">MCN</span>
            <span class="tag">中小企业</span>
          </div>
          <!-- 产品链接占位: 上线后替换为真实地址 -->
          <a class="product-link" href="https://wmzx.gzwmsz.com" target="_blank">了解详情 <span class="arr">→</span></a>
        </div>
        <div class="card product-card reveal" v-reveal>
          <span class="product-badge">已上线</span>
          <p class="card-idx">product / 02</p>
          <h3>微米 AI 自媒体工作台</h3>
          <p>一个装在你电脑里的 AI 内容助手: IP 定位、拆解爆款、灵感、选题、文案、脚本、发布数据、复盘, 串成一条完整链路。每做一条视频的功夫, 都变成下一条的底气。</p>
          <div class="tags">
            <span class="tag">自媒体人</span>
            <span class="tag">内容团队</span>
            <span class="tag">一人公司</span>
          </div>
          <!-- 产品链接占位: 上线后替换为真实地址 -->
          <a class="product-link" href="#">了解详情 <span class="arr">→</span></a>
        </div>
        <div class="card product-card reveal" v-reveal>
          <span class="product-badge dev">开发中</span>
          <p class="card-idx">product / 03</p>
          <h3>微米小程序商城</h3>
          <p>你的生意, 值得一个自己的商城。店铺装修、商品管理、支付、会员, 一个程序全搞定; PC 管店, 微信卖货, 客户和数据握在自己手里。预计 2026 年内上线。</p>
          <div class="tags">
            <span class="tag">零售</span>
            <span class="tag">本地生活</span>
            <span class="tag">品牌商家</span>
          </div>
          <!-- 产品链接占位: 上线后替换为真实地址 -->
          <a class="product-link" href="#">了解详情 <span class="arr">→</span></a>
        </div>
        <div class="card product-card reveal" v-reveal>
          <span class="product-badge">已上线</span>
          <p class="card-idx">product / 04</p>
          <h3>AI 学习社群</h3>
          <p>一个专门帮你在 AI 时代把想法变成产品的地方。核心只做一件事: 你在 AI 编程里卡住的任何问题, 我帮你定位、帮你拆、给你解法。</p>
          <div class="tags">
            <span class="tag">AI 学习者</span>
            <span class="tag">独立开发</span>
            <span class="tag">编程卡点</span>
            <span class="tag">答疑社群</span>
          </div>
          <!-- 产品链接占位: 上线后替换为真实地址 -->
          <a class="product-link" href="https://opc.gzwmsz.com">了解详情 <span class="arr">→</span></a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProductsSection'
}
</script>

<style scoped>
.product-card {
  position: relative;
}

.product-badge {
  position: absolute;
  top: 22px;
  right: 22px;
  font-family: var(--mono);
  font-size: 11px;
  color: var(--accent);
  background: var(--accent-soft);
  border-radius: 999px;
  padding: 3px 10px;
}

.product-badge.dev {
  color: #B25E00;
  background: rgba(255, 176, 0, 0.12);
}

.product-link {
  margin-top: 20px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: var(--ink);
  text-decoration: none;
  transition: color 0.15s;
}

.product-link .arr {
  transition: transform 0.15s;
  font-family: var(--mono);
}

.product-link:hover {
  color: var(--accent);
}

.product-link:hover .arr {
  transform: translateX(4px);
}
</style>
